/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserRewardLedgerEntryReferredUserDetails
 */
export interface UserRewardLedgerEntryReferredUserDetails {
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryReferredUserDetails
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryReferredUserDetails
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRewardLedgerEntryReferredUserDetails
     */
    name?: string;
}

/**
 * Check if a given object implements the UserRewardLedgerEntryReferredUserDetails interface.
 */
export function instanceOfUserRewardLedgerEntryReferredUserDetails(value: object): value is UserRewardLedgerEntryReferredUserDetails {
    return true;
}

export function UserRewardLedgerEntryReferredUserDetailsFromJSON(json: any): UserRewardLedgerEntryReferredUserDetails {
    return UserRewardLedgerEntryReferredUserDetailsFromJSONTyped(json, false);
}

export function UserRewardLedgerEntryReferredUserDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRewardLedgerEntryReferredUserDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function UserRewardLedgerEntryReferredUserDetailsToJSON(json: any): UserRewardLedgerEntryReferredUserDetails {
    return UserRewardLedgerEntryReferredUserDetailsToJSONTyped(json, false);
}

export function UserRewardLedgerEntryReferredUserDetailsToJSONTyped(value?: UserRewardLedgerEntryReferredUserDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
    };
}

